import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Input } from '../root/components/common'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { enqueueSnackbar } from '../root/actions'
import { useQuery } from 'react-query'
import { Highlighted } from '../root/components/common/highlighted'
import { TableVirtualized } from '../root/components/common/table-virtualized/table'
import { getSwapArchive } from './api/swap-replacements-api'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    flexContainer: {
        display: 'flex',
        height: '100%'
    },
    tableWrapper: {
        width: '75%',
        height: '100%'
    },
    detailsWrapper: {
        width: '25%',
        height: '100%',
        overflowY: 'scroll',
        padding: theme.spacing(2)
    },
    searchInput: {
        width: '35%',
        marginTop: 10,
        marginBottom: 20
    }
}))

function SwapReplacementsArchive(props) {
    const classes = useStyles()
    const dispatch = useDispatch()

    const [searchTerm, setSearchTerm] = useState('')
    const [selectedRow, setSelectedRow] = useState(null)

    const handleRowClick = e => {
        setSelectedRow(e.rowData)
    }

    function JsonPretty({ data }) {
        const renderJson = (jsonData, level = 0) => {
            const margin = level * 4
            const entries = Object.entries(jsonData)

            return entries.map(([key, value], index) => (
                <div key={key} style={{ marginLeft: `${margin}px` }}>
                    <span style={{ fontWeight: 'bold' }}>{key}:</span>
                    {typeof value === 'object' && value !== null ? (
                        <div>{renderJson(value, level + 1)}</div>
                    ) : (
                        <span> {JSON.stringify(value)}</span>
                    )}
                </div>
            ))
        }

        return <div>{renderJson(data)}</div>
    }

    const {
        isLoading,
        data = [],
        refetch
    } = useQuery(
        ['swap-archive', searchTerm],
        () => getSwapArchive(searchTerm),
        {
            refetchInterval: false,
            onError: () =>
                dispatch(
                    enqueueSnackbar({
                        message: 'testError',
                        options: {
                            variant: 'error'
                        }
                    })
                )
        }
    )

    useEffect(() => {
        refetch({ searchTerm })
    }, [searchTerm])

    const getReplacedAt = events => {
        const replacedEvent = events.find(
            event => event.event_type === 'replaced'
        )
        if (replacedEvent) {
            const date = new Date(replacedEvent.created_at)
            return date.toLocaleString()
        }
        return 'N/A'
    }

    const columns = [
        {
            key: 'customer_device',
            label: 'Gerät des Kunden',
            sortable: true,
            dataType: 'string',
            width: 1,
            render: ({ cellData }) => (
                <Highlighted text={cellData} highlight={searchTerm} />
            )
        },
        {
            key: 'replacement_device',
            label: 'Ersatzgerät',
            sortable: false,
            width: 1,
            dataType: 'string',
            render: ({ cellData }) => (
                <Highlighted text={cellData} highlight={searchTerm} />
            )
        },
        {
            key: 'customer',
            label: 'Kunde',
            sortable: false,
            dataType: 'custom',
            width: 1,
            alignCenter: true,
            render: ({ cellData }) => (
                <Highlighted text={cellData} highlight={searchTerm} />
            )
        },
        {
            key: 'replaced_at',
            label: 'Replaced At',
            sortable: true,
            dataType: 'string',
            width: 1,
            render: ({ rowData }) => {
                const replacedAt = getReplacedAt(rowData.data.events || [])
                return <span>{replacedAt}</span>
            }
        }
    ]

    return (
        <div className={classes.wrapper}>
            <React.Fragment>
                <Input
                    className={classes.searchInput}
                    label="Search"
                    type="text"
                    setValue={setSearchTerm}
                    value={searchTerm}
                    debounce={600}
                />
                <div className={classes.flexContainer}>
                    <div className={classes.tableWrapper}>
                        <TableVirtualized
                            data={data}
                            rowCount={data.length}
                            isLoading={isLoading}
                            columns={columns}
                            onRowClick={handleRowClick}
                        />
                    </div>
                    <div className={classes.detailsWrapper}>
                        {selectedRow ? (
                            <JsonPretty data={selectedRow.data} />
                        ) : (
                            <p>Bitte wählen die Ersetzung</p>
                        )}
                    </div>
                </div>
            </React.Fragment>
        </div>
    )
}

export default withRouter(SwapReplacementsArchive)
